/*!
 * devextreme-angular-test
 * Version: 17.2.8
 * Build date: Mon Feb 05 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:use-input-property-decorator */

import {
    Component,
    NgModule,
    Host,
    SkipSelf
} from '@angular/core';



import { NestedOptionHost } from '../../core/nested-option';
import { DxoFormat } from './base/format';



export class DxoArgumentFormatComponent extends DxoFormat {
    protected get _optionPath() {
        return 'argumentFormat';
    }


    constructor(  parentOptionHost: NestedOptionHost,
             optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'dxo-argument-format',
    template: '',
    styles: [''],
    providers: [NestedOptionHost],
    inputs: [
        'currency',
        'formatter',
        'parser',
        'precision',
        'type'
    ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }, ]},
{type: NestedOptionHost, decorators: [{ type: Host }, ]},
];
}


export class DxoArgumentFormatModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    DxoArgumentFormatComponent
  ],
  exports: [
    DxoArgumentFormatComponent
  ],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
